import { useEffect } from "react";
import { useLocation, useNavigationType } from "react-router-dom";

/**
 * Send a newly opened page to the top.
 *
 * Without this, following a link from far down one page lands the reader
 * partway down the next one — clicking "View projects" from the bottom of the
 * home page arrives at `/projects` below its own heading.
 *
 * The document sets `scroll-behavior: smooth` for in-page anchors, so a route
 * change has to ask for `instant`; otherwise arriving at a page animates a
 * scroll nobody asked for.
 */
export function useScrollReset(): void {
  const { pathname, hash } = useLocation();
  const navigationType = useNavigationType();

  useEffect(() => {
    // Back and forward should land where the reader left off, and a hash is a
    // request for one particular element rather than the top of the document.
    if (navigationType === "POP" || hash) return;
    window.scrollTo({ top: 0, left: 0, behavior: "instant" });
  }, [pathname, hash, navigationType]);
}
